var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPostsActive = function SvgPostsActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic-posts")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gosite-SVG-Icons",
    transform: "translate(-502.000000, -364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-posts",
    transform: "translate(502.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,1.8 C18.8807119,1.8 20,2.91928813 20,4.3 L20,17.3 C20,18.6807119 18.8807119,19.8 17.5,19.8 L2.5,19.8 C1.11928813,19.8 1.69088438e-16,18.6807119 0,17.3 L0,4.3 C-1.69088438e-16,2.91928813 1.11928813,1.8 2.5,1.8 L17.5,1.8 Z M17.5,3.3 L2.5,3.3 C1.94771525,3.3 1.5,3.74771525 1.5,4.3 L1.5,4.3 L1.5,17.3 C1.5,17.8522847 1.94771525,18.3 2.5,18.3 L2.5,18.3 L17.5,18.3 C18.0522847,18.3 18.5,17.8522847 18.5,17.3 L18.5,17.3 L18.5,4.3 C18.5,3.74771525 18.0522847,3.3 17.5,3.3 L17.5,3.3 Z",
    id: "Combined-Shape",
    fill: "#0A1E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A1E3B",
    x: 4,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A1E3B",
    x: 7.7,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A1E3B",
    x: 11.4,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0A1E3B",
    x: 15.1,
    y: 0,
    width: 1,
    height: 5,
    rx: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,11.3 L14.60002,11.3 M4.5,8.3 L12.60002,8.3 M4.5,14.3 L9.5,14.3",
    id: "Combined-Shape",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPostsActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/posts-active.4990b6e5.svg";
export { ForwardRef as ReactComponent };